import * as Sentry from '@sentry/react';
export var captureError = function(err) {
    var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    console.error(err);
    Sentry.captureException(err, hint);
};
